import { graphql, useStaticQuery } from 'gatsby'
import { Container, Col } from '@ui/wrapper'
import Text from '@ui/text'
import Anchor from '@ui/anchor'
import Heading from '@ui/heading'
import {
  FooterWrap,
  FooterTop,
  FooterWidget,
  LogoWidget,
  FooterWidgetList,
  FooterBottom,
  FooterRow
} from './style'
import LogoSvg from '../../../assets/images/logo/dark-logo.svg'
import { usePageContext } from '@context/PageContext'
import SocialIcons from '@ui/social-icons'

const Footer = () => {
  const { locale } = usePageContext()

  const allFooterData = useStaticQuery(graphql`
    query {
      allStrapiGeneral {
        nodes {
          ...StrapiFooter
          locale
        }
      }
    }
  `)
  const data =
    allFooterData.allStrapiGeneral.nodes.find((f) => f.locale === locale)
      ?.footer || {}

  return (
    <FooterWrap>
      <FooterTop>
        <Container>
          <FooterRow>
            <Col lg={4} sm={6}>
              <FooterWidget mb={['31px', null, null, 0]}>
                <LogoWidget>
                  <img
                    src={LogoSvg}
                    className="light-logo"
                    alt="logo"
                    style={{ width: 193, height: 58 }}
                  />
                </LogoWidget>
              </FooterWidget>
            </Col>
            {data.items?.map((item, i) => (
              <Col
                lg={{ span: i === 1 ? 3 : 2, offset: i === 0 ? 1 : 0 }}
                sm={6}
                key={i}
              >
                <FooterWidget mb={['31px', null, null, 0]}>
                  <div
                    style={{
                      minHeight: '30px',
                      marginTop: '-3px',
                      marginBottom: '20px'
                    }}
                  >
                    {item.title && <Heading as="h6">{item.title}</Heading>}
                  </div>
                  <FooterWidgetList>
                    {item.texts?.map((t, i) => (
                      <li key={i}>
                        <Anchor
                          path={t.media?.localFile?.publicURL || t.path}
                          color="footer"
                          $hover={{ layout: 2 }}
                        >
                          {t.content}
                        </Anchor>
                      </li>
                    ))}
                  </FooterWidgetList>
                </FooterWidget>
              </Col>
            ))}
          </FooterRow>
        </Container>
      </FooterTop>
      <FooterBottom>
        <Container>
          <FooterRow>
            <Col md={6} textAlign={['center', null, 'left']}>
              {data?.copyright && (
                <Text pb={['15px', 0]}>
                  &copy; {new Date().getFullYear()}{' '}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: data.copyright
                    }}
                  />
                </Text>
              )}
            </Col>
            <Col md={6} textAlign={['center', null, 'right']}>
              {data?.socials && <SocialIcons socials={data.socials} />}
            </Col>
          </FooterRow>
        </Container>
      </FooterBottom>
    </FooterWrap>
  )
}

export default Footer
